import paths from '@src/paths';

const navItems = [
  {
    key: 'performance',
    title: 'Performance',
    items: [
      { key: 'dailyPulse', title: 'Client Pulse', href: paths.dashboard.dailyPulse, icon: 'calendar-check' },
      { key: 'dataHealth', title: 'Data Health', href: paths.dashboard.dataHealth, icon: 'heartbeat' },
      { key: 'performanceTrends', title: 'Performance Trends', href: paths.dashboard.performanceTrends, icon: 'pulse' },
      { key: 'companyPerformance', title: 'Company Performance', href: paths.dashboard.companyPerformance, icon: 'table' },
      { key: 'genderPerformance', title: 'Gender Performance', href: paths.dashboard.genderPerformance, icon: 'table' },
      { key: 'clientPerformanceAggregator', title: 'Creative Performance', href: paths.dashboard.clientPerformanceAggregator, icon: 'table' },
      { key: 'designerCreativePerformance', title: 'Designer Creative Performance', href: paths.dashboard.designerCreativePerformance, icon: 'table' },
    ],
  },
  {
    key: 'clients',
    title: 'Clients',
    items: [
      { key: 'clientList', title: 'Clients', href: paths.clients, icon: 'users' },
      { key: 'clientCreate', title: 'New Client', href: paths.clientCreate, icon: 'plus-circle' },
      { key: 'onboardingFlow', title: 'Onboarding', href: paths.onboarding.list, icon: 'list-checks' },
      { key: 'prospects', title: 'Prospects', href: paths.prospects, icon: 'user-plus' },
      { key: 'clientInvites', title: 'Invite Members', href: paths.clientInvites, icon: 'envelope-simple' },
      { key: 'clientOffers', title: 'Client Offers', href: paths.clientOffers, icon: 'receipt' },
    ],
  },
  {
    key: 'targetingBudget',
    title: 'Targeting & Budget',
    items: [
      { key: 'clientZips', title: 'Client Zips', href: paths.clientZips, icon: 'map-pin' },
      { key: 'zipCoverage', title: 'ZIP Coverage', href: paths.zipCoverage, icon: 'map-pin' },
      { key: 'zipSubmissions', title: 'ZIP Submissions', href: '/clients/zip-submissions', icon: 'clipboard-check' },
      { key: 'clientLanes', title: 'Client Lanes', href: paths.clientLanes, icon: 'table' },
      { key: 'clientBudgets', title: 'Client Budgets', href: paths.clientBudgets, icon: 'trend-up' },
      { key: 'budgetCenter', title: 'Budget Center', href: paths.budgetCenter, icon: 'table' },
      { key: 'budgetSubmissions', title: 'Budget Submissions', href: paths.budgetSubmissions, icon: 'clipboard-check' },
      { key: 'budgetOptimizer', title: 'Budget Optimizer', href: paths.facebook.budgetOptimizer, icon: 'trend-up' },
      { key: 'zipTargetingAnalyzer', title: 'ZIP Targeting Analyzer', href: paths.zipTargetingAnalyzer, icon: 'sparkle' },
      { key: 'pacingControl', title: 'Pacing Control', href: paths.pacingControl, icon: 'gauge' },
      { key: 'campaignBuilder', title: 'Campaign Builder', href: paths.facebook.campaignBuilder, icon: 'share-network' },
    ],
  },
  {
    key: 'leadsData',
    title: 'Leads & Data',
    items: [
      {
        key: 'leads',
        title: 'Leads',
        icon: 'user-focus',
        items: [
          { key: 'leadsList', title: 'List Leads', href: paths.leads.list },
        ],
      },
      { key: 'leadDelivery', title: 'Lead Delivery', href: '/lead-delivery', icon: 'plugs-connected' },
      {
        key: 'backendData',
        title: 'Backend Data',
        icon: 'table',
        items: [
          { key: 'backendDataList', title: 'List Records', href: paths.backendData.list },
          { key: 'backendDatasummary', title: 'Summary', href: paths.backendData.summary },
        ],
      },
      { key: 'dataIntegrations', title: 'Data Integrations', href: paths.dataIntegrations.health, icon: 'link-simple' },
      { key: 'emailMappings', title: 'Backend Mappings', href: paths.emailMappings, icon: 'link-simple' },
      { key: 'dataBackfill', title: 'Data Backfill', href: paths.dashboard.dataBackfill, icon: 'calendar-check' },
    ],
  },
  {
    key: 'creative',
    title: 'Creative & Ads',
    items: [
      { key: 'creativeTasks', title: 'Creative Flights', href: paths.creativeTasks, icon: 'airplane' },
      { key: 'clientCreativeKnowledge', title: 'Creative Knowledge', href: paths.clientCreativeKnowledge, icon: 'book-open-text' },
      { key: 'creativeStudio', title: 'Creative Studio', href: paths.creativeStudio, icon: 'film-slate' },
      { key: 'adNameBuilder', title: 'Ad Name Builder', href: paths.adBuilder, icon: 'file' },
    ],
  },
  {
    key: 'communications',
    title: 'Communications',
    items: [
      { key: 'clientInbox', title: 'Client Inbox', href: paths.clientInbox, icon: 'envelope-simple' },
      { key: 'agentChat', title: 'Agent Chat', href: paths.agentChat, icon: 'chat-circle' },
      { key: 'notifications', title: 'Notifications', href: paths.notifications, icon: 'bell' },
    ],
  },
  {
    key: 'admin',
    title: 'Admin & Tools',
    items: [
      {
        key: 'invoices',
        title: 'Invoices',
        icon: 'receipt',
        items: [
          { key: 'invoices:list', title: 'List invoices', href: paths.dashboard.invoices.list },
          { key: 'invoices:create', title: 'Create invoice', href: paths.dashboard.invoices.create },
          { key: 'invoices:settings', title: 'Invoice settings', href: paths.dashboard.invoices.settings },
          { key: 'invoices:details', title: 'Invoice details', href: paths.dashboard.invoices.details(':invoiceId'), disabled: true },
        ],
      },
      { key: 'tasks', title: 'Tasks', href: paths.dashboard.tasks, icon: 'kanban' },
      { key: 'taskLogger', title: 'Task Logger', href: paths.taskLogger, icon: 'list-checks' },
      { key: 'knowledgeBase', title: 'Knowledge Base', href: paths.knowledgeBase, icon: 'book' },
      { key: 'developerApi', title: 'Developer API', href: paths.dashboard.settings.apiAccess, icon: 'code' },
    ],
  },
];

function filterNavItemsForUser(items = [], user, options = {}) {
  if (!user) {
    return [];
  }

  if (user.is_staff || user.is_superuser) {
    return items;
  }

  // Creative designers see only Creative Flights, Creative Knowledge (read-only), and Client Lanes (read-only).
  if (user.is_creative_designer) {
    return [
      {
        key: 'creative-designer-group',
        title: 'Creative',
        items: [
          {
            key: 'creativeTasks',
            title: 'Creative Flights',
            href: paths.creativeTasks,
            icon: 'airplane',
          },
          {
            key: 'creativeKnowledge',
            title: 'Creative Knowledge',
            href: paths.creativeKnowledge,
            icon: 'book',
          },
          {
            key: 'clientLanes',
            title: 'Client Lanes',
            href: paths.clientLanes,
            icon: 'table',
          },
          {
            key: 'designerCreativePerformance',
            title: 'Creative Performance',
            href: paths.dashboard.designerCreativePerformance,
            icon: 'table',
          },
        ],
      },
    ];
  }

  const normalizeSlug = (value = '') =>
    value.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
  const getMembershipDashboardSlug = (membership = {}) => {
    const clientSlug = membership?.client_slug || membership?.client_id;
    if (clientSlug) {
      return clientSlug;
    }
    const parentName = membership?.parent_company_name;
    if (parentName) {
      return normalizeSlug(parentName);
    }
    return membership?.parent_company_id || null;
  };

  const memberships = Array.isArray(user.client_memberships) ? user.client_memberships : [];
  const parentScopeClients = Array.isArray(options.parentScopeClients)
    ? options.parentScopeClients
    : [];
  if (memberships.length) {
    const defaultMembership = memberships[0];
    const clientSlug = getMembershipDashboardSlug(defaultMembership);
    const budgetCenterEnabled = true;
    const showZipCoverage = true;
    const budgetNeedsAttention = memberships.some((m) => m?.budget_needs_attention);
    const invoicesOutstandingCount = memberships.reduce(
      (sum, m) => sum + (parseInt(m?.invoices_outstanding_count, 10) || 0),
      0,
    );
    const clientBudgetCenterHref = defaultMembership?.client_id
      ? `${paths.budgetCenter}?client_id=${defaultMembership.client_id}`
      : paths.budgetCenter;
    const clientPacingControlHref = defaultMembership?.client_id
      ? `${paths.pacingControl}?client_id=${defaultMembership.client_id}`
      : paths.pacingControl;
    const clientLeadHref = defaultMembership?.client_id
      ? `${paths.leads.list}?client_id=${defaultMembership.client_id}`
      : null;
    const clientStatus = String(defaultMembership?.client_status || '').toLowerCase();
    const onboardingAllowed = ['new_business', 'onboarding'].includes(clientStatus);
    const isParentScopeMembership = !defaultMembership?.client_id && Boolean(
      defaultMembership?.parent_company_id || defaultMembership?.parent_company_name
    );

    // If we can't resolve a client identifier, fail closed and hide the menu.
    if (!clientSlug) {
      return [];
    }

    if (onboardingAllowed) {
      return [
        {
          key: 'client-onboarding-group',
          title: 'Onboarding',
          items: [
            {
              key: 'client-onboarding',
              title: 'Onboarding',
              href: paths.onboarding.forClient(clientSlug),
              icon: 'list-checks',
            },
            {
              key: 'client-webhook-setup',
              title: 'Lead Delivery Setup',
              href: paths.webhookSetup(clientSlug),
              icon: 'plugs-connected',
            },
          ],
        },
      ];
    }

    if (isParentScopeMembership) {
      const isFiveStarParent = defaultMembership?.parent_company_id === 1;
      const normalizedDefaultSlug = normalizeSlug(
        defaultMembership?.parent_company_name || ''
      );
      const sortedClients = [...parentScopeClients]
        .map((client = {}) => ({
          id: client.id,
          name: client.name || `Client ${client.id}`,
          slug: client.slug || normalizeSlug(client.name || String(client.id || '')),
          status: (client.status || '').toLowerCase(),
        }))
        .filter((client) => Boolean(client.slug))
        .filter((client) => normalizeSlug(client.slug) !== normalizedDefaultSlug)
        .sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }));

      // Separate onboarding clients from active ones
      const onboardingClients = sortedClients.filter((c) => ['new_business', 'onboarding'].includes(c.status));
      const activeClients = sortedClients.filter((c) => !['new_business', 'onboarding'].includes(c.status));

      const clientLinks = activeClients.map((client) => ({
        key: `parent-client-dashboard-${client.id}`,
        title: client.name,
        href: paths.clientDashboard(client.slug),
      }));
      const onboardingLinks = onboardingClients.map((client) => ({
        key: `parent-client-onboarding-${client.id}`,
        title: client.name,
        href: `/onboarding/${client.slug}`,
        icon: 'list-checks',
        external: true,
      }));
      const parentClientNavItems = [...clientLinks];

      return [
        {
          key: 'client-dashboard-group',
          title: 'Overview',
          items: [
            {
              key: 'client-dashboard',
              title: 'Performance Dashboard',
              href: paths.clientDashboard(clientSlug),
              icon: 'chart-pie',
            },
            ...(budgetCenterEnabled
              ? [
                  {
                    key: 'client-budget-center',
                    title: 'Budget Center',
                    href: clientBudgetCenterHref,
                    icon: 'table',
                    label: budgetNeedsAttention ? 'Action Needed' : 'New',
                  },
                ]
              : []),
            // Pacing Control hidden from client sidebar pending more testing.
            // Staff still see it via the main "Targeting & Budget" sidebar group.
            ...(showZipCoverage
              ? [
                  {
                    key: 'client-zip-coverage',
                    title: 'ZIP Coverage',
                    href: defaultMembership?.client_id
                      ? `/zip-coverage?client_id=${defaultMembership.client_id}`
                      : '/zip-coverage',
                    icon: 'map-pin',
                    label: 'New',
                  },
                ]
              : []),
            ...(clientLeadHref
              ? [
                  {
                    key: 'client-leads',
                    title: 'Leads',
                    href: clientLeadHref,
                    icon: 'user-focus',
                  },
                ]
              : []),
            ...(parentClientNavItems.length
              ? [
                  {
                    key: 'parent-client-dashboards',
                    title: 'Clients',
                    icon: 'users',
                    items: parentClientNavItems,
                  },
                ]
              : []),
            ...(isFiveStarParent
              ? [
                  {
                    key: 'parent-five-star-get-started',
                    title: 'New Branch',
                    href: '/get-started/five-star',
                    icon: 'share-network',
                    external: true,
                    label: 'Share',
                  },
                ]
              : []),
            ...onboardingLinks,
          ],
        },
        {
          key: 'client-account-group',
          title: 'Account',
          items: [
            {
              key: 'client-invoices',
              title: 'Invoices',
              href: paths.myInvoices.list,
              icon: 'receipt',
              ...(invoicesOutstandingCount > 0 ? { label: `${invoicesOutstandingCount} Due` } : {}),
            },
            {
              key: 'client-webhook-setup',
              title: 'Lead Delivery',
              href: isParentScopeMembership ? '/lead-delivery' : paths.webhookSetup(clientSlug),
              icon: 'plugs-connected',
              label: 'New',
            },
            {
              key: 'client-data-integrations',
              title: 'Data Integrations',
              href: paths.dataIntegrations.root,
              icon: 'database',
              label: 'New',
            },
            {
              key: 'client-team',
              title: 'Team',
              href: paths.teamManagement,
              icon: 'users',
            },
            {
              key: 'client-api-access',
              title: 'Developer API',
              href: paths.dashboard.settings.apiAccess,
              icon: 'code',
            },
            {
              key: 'client-settings',
              title: 'Settings',
              href: paths.dashboard.settings.account,
              icon: 'gear-six',
            },
          ],
        },
      ];
    }

    // Five Star Bath Solutions clients (parent_company_id=1) get a simplified nav
    const isFiveStarClient = defaultMembership?.client_parent_company_id === 1;

    return [
      {
        key: 'client-dashboard-group',
        title: 'Overview',
        items: [
          {
            key: 'client-dashboard',
            title: 'Performance Dashboard',
            href: paths.clientDashboard(clientSlug),
            icon: 'chart-pie',
          },
          ...(!isFiveStarClient && budgetCenterEnabled
            ? [
                {
                  key: 'client-budget-center',
                  title: 'Budget Center',
                  href: clientBudgetCenterHref,
                  icon: 'table',
                  label: budgetNeedsAttention ? 'Action Needed' : 'New',
                },
              ]
            : []),
          // Pacing Control hidden from client sidebar pending more testing.
          // Staff still see it via the main "Targeting & Budget" sidebar group.
          ...(!isFiveStarClient && showZipCoverage
            ? [
                {
                  key: 'client-zip-coverage',
                  title: 'ZIP Coverage',
                  href: defaultMembership?.client_id
                    ? `/zip-coverage?client_id=${defaultMembership.client_id}`
                    : '/zip-coverage',
                  icon: 'map-pin',
                  label: 'New',
                },
              ]
            : []),
          ...(clientLeadHref
            ? [
                {
                  key: 'client-leads',
                  title: 'Leads',
                  href: clientLeadHref,
                  icon: 'user-focus',
                },
              ]
            : []),
        ],
      },
      {
        key: 'client-account-group',
        title: 'Account',
        items: [
          {
            key: 'client-invoices',
            title: 'Invoices',
            href: paths.myInvoices.list,
            icon: 'receipt',
          },
          ...(!isFiveStarClient
            ? [
                {
                  key: 'client-webhook-setup',
                  title: 'Lead Delivery',
                  href: paths.webhookSetup(clientSlug),
                  icon: 'plugs-connected',
                  label: 'New',
                },
              ]
            : []),
          ...(isFiveStarClient
            ? [
                {
                  key: 'client-email-notifications',
                  title: 'Email Notifications',
                  href: paths.emailNotifications,
                  icon: 'envelope-simple',
                },
              ]
            : []),
          ...(!isFiveStarClient
            ? [
                {
                  key: 'client-data-integrations',
                  title: 'Data Integrations',
                  href: paths.dataIntegrations.root,
                  icon: 'database',
                  label: 'New',
                },
              ]
            : []),
          {
            key: 'client-team',
            title: 'Team',
            href: paths.teamManagement,
            icon: 'users',
          },
          {
            key: 'client-api-access',
            title: 'Developer API',
            href: paths.dashboard.settings.apiAccess,
            icon: 'code',
          },
          {
            key: 'client-settings',
            title: 'Settings',
            href: paths.dashboard.settings.account,
            icon: 'gear-six',
          },
        ],
      },
    ];
  }

  const allowedKeys = new Set([
    'clientList',
    'clientZips',
    'clientBudgets',
    'onboardingFlow',
    'clientInbox',
    'knowledgeBase',
  ]);

  const filterItems = (list = []) =>
    list
      .map((item) => {
        const nextItems = item.items ? filterItems(item.items) : [];
        const keepSelf = allowedKeys.has(item.key);
        if (nextItems.length) {
          return { ...item, items: nextItems };
        }
        return keepSelf ? { ...item, items: undefined } : null;
      })
      .filter(Boolean);

  return items
    .map((group) => {
      const nextItems = filterItems(group.items || []);
      return { ...group, items: nextItems };
    })
    .filter((group) => group.items && group.items.length);
}

export default { navItems };
export { filterNavItemsForUser };
